// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i1-0";
export var actionModalContentContainer = "_i1-1";
export var createTagButton = "_i1-2";
export var footerContainer = "_i1-7";
export var fullWidthDivider = "_i1-3";
export var hasCreateTagButton = "_i1-4";
export var noCreateTagButton = "_i1-5";
export var tagsContainer = "_i1-6";
export var tagsModalContentContainer = "_i1-8";